export default function GameLoadingOverlay({
  visible,
  progress = 0,
  message = 'Preparando el juego…',
  error = '',
  readyAction = null,
  onRetry,
}) {
  if (!visible) return null;

  const safeProgress = Math.max(0, Math.min(100, Math.round(progress)));

  return (
    <div className="rhythm-loader" aria-live="polite" aria-busy={!error && !readyAction}>
      <div className="rhythm-loader-card" role={error ? 'alert' : 'status'}>
        <p className="rhythm-loader-kicker">La Maldición del Ñaca Ñaca</p>
        <h1>{error ? 'El ritual se interrumpió' : readyAction ? 'Todo está listo' : 'Invocando la noche'}</h1>

        {!error && !readyAction && (
          <>
            <div className="rhythm-loader-track" aria-hidden="true">
              <span style={{ transform: `scaleX(${safeProgress / 100})` }} />
            </div>
            <progress className="rhythm-loader-native" max="100" value={safeProgress}>{safeProgress}%</progress>
            <p className="rhythm-loader-percent">{safeProgress}%</p>
          </>
        )}

        <p className={error ? 'rhythm-loader-error' : 'rhythm-loader-message'}>{error || message}</p>

        {error && (
          <button type="button" onClick={onRetry}>Recargar el juego</button>
        )}
        {!error && readyAction && (
          <button type="button" onClick={readyAction.onClick}>{readyAction.label}</button>
        )}
      </div>
    </div>
  );
}

